import { cn, Typography } from '@prenuvo/halo';

import { Required } from '@/shared/ui';
import { isEmpty } from '@/shared/util';

import { IssueType } from '../report-issue-handler.model';

type CommonLabelProps = {
  isRequired?: boolean;
  issueType?: IssueType;
  labelText: string;
  showErrors: boolean;
  title: string;
};

function ReportCommonLabel({
  isRequired,
  issueType,
  labelText,
  showErrors,
  title,
}: CommonLabelProps) {
  return (
    <Required isRequired={isRequired}>
      <Typography
        as="label"
        className={cn('text-neutral-400 dark:text-neutral-400', {
          'text-red-500 dark:text-red-500':
            (showErrors &&
              isEmpty(title) &&
              labelText === 'FCT.REPORTING.REPORT_ISSUE.LABEL.TITLE') ||
            (showErrors &&
              !issueType &&
              labelText === 'FCT.REPORTING.REPORT_ISSUE.LABEL.WHAT_WOULD_YOU_LIKE_TO_DO'),
        })}
        translationKey={labelText}
        variant="paragraph-sm"
      />
    </Required>
  );
}

export { ReportCommonLabel };
